import { useMemo } from 'react';
import DeviceInfo from 'react-native-device-info';
import { MEDICAL_DEVICE_UDI } from '@shared/constants/medicalDevice';
import {
  SOFTWARE_LABEL_DEVICE_NAME,
  SOFTWARE_LABEL_EIFU_URL,
  SOFTWARE_LABEL_ENABLED,
  SOFTWARE_LABEL_MANUFACTURER_LINES,
  SOFTWARE_LABEL_NOTIFIED_BODY_NUMBER,
  SOFTWARE_LABEL_RELEASE_DATE,
  SOFTWARE_LABEL_SOFTWARE_NAME,
} from '@shared/constants/softwareLabel';
import type { TSoftwareLabel } from '../types/softwareLabelTypes';

export const useSoftwareLabel = () => {
  const softwareLabel = useMemo<TSoftwareLabel>(() => {
    const serialNumber = [SOFTWARE_LABEL_SOFTWARE_NAME, DeviceInfo.getVersion()]
      .filter(Boolean)
      .join(' ')
      .trim();

    return {
      notifiedBodyNumber: SOFTWARE_LABEL_NOTIFIED_BODY_NUMBER,
      deviceName: SOFTWARE_LABEL_DEVICE_NAME,
      udiDeviceIdentifier: MEDICAL_DEVICE_UDI,
      udiProductionIdentifier: serialNumber ? `(21)${serialNumber}` : '',
      manufacturer: SOFTWARE_LABEL_MANUFACTURER_LINES,
      releaseDate: SOFTWARE_LABEL_RELEASE_DATE,
      serialNumber,
      eifuUrl: SOFTWARE_LABEL_EIFU_URL,
    };
  }, []);

  return { isSoftwareLabelEnabled: SOFTWARE_LABEL_ENABLED, softwareLabel };
};
